import axios from "axios";

/**
 * Convenience method that wraps Axios and generates a request for us with some
 * preset settings.
 *
 * @param {String} method
 * @param {String} pathname
 * @param {Object} body
 * @param {Object} opts
 */
export function send(method, pathname, body, opts = {}) {
  const instanceOptions = {
    baseURL: __API_DOMAIN__,
    headers: {
      Accept: "application/json",
      ...opts.headers,
    },
  };

  // NOTE(Patrick): Certain endpoints in our Django application still accept form encoded
  // data but return JSON. Once all those endpoints are modified to accept JSON, we can remove this.
  if (body instanceof URLSearchParams) {
    instanceOptions.headers["content-type"] =
      "application/x-www-form-urlencoded;charset=UTF-8";
    instanceOptions.body = body.toString(); //= > 'foo=123&foo=456&bar=hello%2Cworld'
  } else if (body != null) {
    instanceOptions.body = body; // let httpie deal w/ it
  }

  // NOTE(Patrick): We set withCredentials to true by default because many of our
  // endpoints rely on the _userId cookie to be set.
  instanceOptions.withCredentials =
    opts.withCredentials || opts.withCredentials == null;

  const ax = axios.create(instanceOptions);

  return ax({
    method,
    url: pathname,
    data: body,
  }).then((r) => r.data);
}

export default send;
